import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function AuthGuard() {
  const { user, profile, loading } = useAuth();
  
  if (loading) return <div className="min-h-screen flex items-center justify-center">Cargando...</div>;
  
  if (user && profile && !profile.isComplete) {
    return <Navigate to="/auth" replace />;
  }
  
  return <Outlet />;
}
